import React from 'react';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
function DependencyList(props) {
    const { dependencies } = props;
    if (dependencies.length <= 0) {
        return null;
    }
    return (React.createElement("div", { className: "c-manifest-dependencies__dependency-list" },
        React.createElement("div", { className: "c-manifest-dependencies__text c-manifest-dependencies__dependency-list-title" }, MessageService.translate('tws.manifest-dependencies.dependencies-title')),
        dependencies.map(dependency => (React.createElement("div", { className: "c-manifest-dependencies__dependency", key: dependency.name }, MessageService.translate('tws.manifest-dependencies.dependency-item', { ...dependency }))))));
}
export { DependencyList, };
//# sourceMappingURL=dependency-list.js.map